export default __webpack_public_path__ + "static/media/Loading.63d7da1b.gif";